import React, { FunctionComponent } from 'react'
import styles from './GalleryHeader.module.sass'
import Selector from '../../../Selector'
import { objectSelector, projectSelector } from '../../../../../utils/selectors'
import ObjectName from '../../../ObjectName/ObjectName'
import { GalleryData } from '../../../../../redux/global/gallery/gallery-actions'
import clsx from 'clsx'

interface Props {
    className?: string,
    data: GalleryData,
}

const GalleryHeader: FunctionComponent<Props> = props => {
    return <div className={clsx(props.className, styles.header, styles[props.data.type])}>
        <div className={styles.info}>
            {props.data.type === 'single' && 'Комментарий'}
            {props.data.type === 'task' && <div className={styles.top}>Результат работы</div>}
            {props.data.type === 'comment' && <div className={styles.top}>Лента комментариев</div>}
            {
                (props.data.type === 'task' || props.data.type === 'comment') && <Selector
                    selector={objectSelector(props.data.objectId)}
                    render={object => <ObjectName className={styles.object} object={object}/>}
                />
            }
            {
                props.data.type === 'project' && <>
                    <div className={styles.top}>Бриф проекта</div>
                    <Selector
                        selector={projectSelector(props.data.projectId)}
                        render={project => project?.short_name}
                    />
                </>
            }
            {
                props.data.type === 'object' && <>
                    <div className={styles.top}>Бриф объекта</div>
                    <Selector
                        selector={objectSelector(props.data.objectId)}
                        render={object => <ObjectName className={styles.object} object={object}/>}
                    />
                </>
            }
        </div>
        {props.children}
    </div>
}

export default GalleryHeader